function isSubscriber(devPort, userName, setCurrentMembership) {
  fetch(devPort + "system_get_manager/" + userName, {
    credentials: "include",
  })
    .then((response) => {
      if (response.status === 401) {
        console.log("Session expired");
        return null;
      }
      return response.json();
    })
    .then((data) => {
      if (!data) return;
      if (data && data[0][0]) {
        setCurrentMembership("manager");
      } else {
        fetch(devPort + "system_get_player/" + userName, {
          credentials: "include",
        })
          .then((idResponse) => {
            if (idResponse.status === 401) return null;
            return idResponse.json();
          })
          .then((idData) => {
            if (!idData) return;
            if (idData && idData[0][0]) {
              console.log("Player Account Found");
              setCurrentMembership("player");
            } else {
              console.log("NO ACCOUNT FOUND");
            }
          });
      }
    });
}

export default isSubscriber;
